import {Controller} from '@hotwired/stimulus';
import {application} from 'src';
import './component.scss';

application.register(
  'scroll-to-button',
  class extends Controller {
    static targets = ['button'];
    static values = { range: Number };

    connect() {
      window.addEventListener('scroll', this.#toggleButtonVisibility.bind(this))
    }

    #toggleButtonVisibility(){
      if (document.body.scrollTop > this.rangeValue || document.documentElement.scrollTop > this.rangeValue) {
        this.buttonTarget.style.display = '';
        this.buttonTarget.style.left = '20px';
        this.buttonTarget.style.opacity = '100%';
      } else {
        this.buttonTarget.style.left = '-150px';
        this.buttonTarget.style.opacity = '0%';
      }
    }
  }
);
